import React from 'react';
import { prefix } from '../../../../constants';
export const SkeletonText = ({ children, loading, width = '100%', }) => {
    if (loading) {
        return React.createElement("span", { className: `${prefix}-skeleton-text`, style: { width } });
    }
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=SkeletonText.js.map